import React from "react";
import Select from 'react-select';
import {Link} from 'react-router-dom';
import CreateEntityMessage from "../Commons/CreateEntityMessage";
import CompanyBalance from "../Balance/CompanyBalance";

const HistoryEntity = (props) => {

    const {
        transactions,
        currentUser,
        handleCompany,
        selectedCompany,
        companies,
        companyInvoices,
        currentAdmin,
        showBalancePopup,
    } = props;

    const { data, isFetching } = transactions;

    let options = [];
    companies.data.results.map((item, index) =>
        options.push({
            value: item.id,
            label: item.title,
        })
    );

    return (
        selectedCompany
        ?
        <div className="tab-content profile-info tab-content1 active">

            <div style={{padding: '10px 30px 0 30px', position:'relative', zIndex: 5}}>
                <Select
                    name="form-field-name"
                    noResultsText="Список пуст"
                    value={selectedCompany && selectedCompany.id}
                    onChange={(company) => handleCompany(company)}
                    clearable={false}
                    options={options}
                />
            </div>

            <CompanyBalance
                currentAdmin={currentAdmin}
                selectedCompany={selectedCompany}
                showBalancePopup={(company) => showBalancePopup(company)}
                />

            {
                companyInvoices.data.results.length > 0 ?
                <div className="operations-history">
                    <h3>Операции в обработке</h3>
                    <ul className="items-list operations-history-list">
                    {
                        companyInvoices.data.results.map((item, index) =>
                            <li key={index} className="list-item">
                                <div className="name">Пополнение баланса (ждет подтверждения администратора)</div>
                                <div className={"balance-change text_green"}>{item.amount} р.</div>
                            </li>
                        )
                    }
                    </ul>
                </div>
                : null
            }

            <div className="operations-history">
                <h3>История операций</h3>
                <ul className="items-list operations-history-list">
                {
                    isFetching ?
                    <li className="list-item">Загружается...</li>
                    :
                        data.results.length ? data.results.map((item, index) =>
                            <li key={index} className="list-item">
                                {
                                    item.order_id
                                    ? <Link to={`/makeorder/${item.order_id}`} className="name">{item.title}</Link>
                                    : <div className="name">{item.title}</div>
                                }
                                <div className={item.change_balance < 0 ? "balance-change text_red" : "balance-change text_green"}>{item.change_balance} р.</div>
                            </li>
                        )
                        : <li className="list-item">Операций нет</li>
                }
                </ul>
            </div>
        </div>
        :
        <CreateEntityMessage id={currentUser.id}/>
    )
}

export default HistoryEntity;


// WEBPACK FOOTER //
// ./src/components/Profile/SubHistory/HistoryEntity.js